import { render, staticRenderFns } from "./import-messaggi-list.vue?vue&type=template&id=235f2ff0&"
import script from "./import-messaggi-list.vue.ts?vue&type=script&lang=ts&"
export * from "./import-messaggi-list.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports